import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function animationPageHeader() {
  /* ====================================
  # ページヘッダータイトルのアニメーション
  ==================================== */
  const pageHeaderTitles = document.querySelectorAll('.c-page-header__titles');
  
  pageHeaderTitles.forEach((titles) => {
    gsap.set(titles, {
      opacity: 0,
      x: -50
    });
    
    gsap.to(titles, {
      opacity: 1,
      x: 0,
      duration: 2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: titles,
        start: "top 80%",
        end: "bottom 20%",
        toggleActions: "play none none reverse",
        onEnter: () => {
          titles.classList.add('is-animated');
        },
        onLeave: () => {
          titles.classList.remove('is-animated');
        },
        onEnterBack: () => {
          titles.classList.add('is-animated');
        },
        onLeaveBack: () => {
          titles.classList.remove('is-animated');
        }
      }
    });
  });

  /* ====================================
  # ページヘッダー光の点エフェクト初期化
  ==================================== */
  const initPageHeaderLightAnimation = () => {
    const pageHeaderElements = document.querySelectorAll('.c-page-header');

    pageHeaderElements.forEach((pageHeader) => {
      const bgLineElement = pageHeader.querySelector('.c-page-header__bg-line');
      if (bgLineElement) {
        addPageHeaderLightDot(bgLineElement, pageHeader);
      }
    });
  };

  /* ====================================
  # ページヘッダー光の点エフェクト
  ==================================== */
  const addPageHeaderLightDot = (svgElement, container) => {
    // SVG内のpath要素を探す
    const pathElements = svgElement.querySelectorAll('path[stroke]') || svgElement.querySelectorAll('path');
    
    if (pathElements.length > 0) {
      createPageHeaderLightDot(pathElements[0], container);
    }
  };

  const createPageHeaderLightDot = (pathElement, container) => {
    // 光の点要素を作成
    const lightDot = document.createElement('div');
    lightDot.className = 'page-header-light-dot';

    // コンテナに追加
    container.appendChild(lightDot);

    // パスの長さを取得
    const pathLength = pathElement.getTotalLength();
    let currentDistance = 0;
    let isAnimating = false;
    let animationStarted = false;

    // 光の軌跡用のパスを作成
    const trailPath = pathElement.cloneNode(true);
    trailPath.style.stroke = '#999999'; // グレー色
    trailPath.style.strokeWidth = pathElement.style.strokeWidth || pathElement.getAttribute('stroke-width') || '1';
    trailPath.style.strokeDasharray = pathLength;
    trailPath.style.strokeDashoffset = pathLength;
    trailPath.style.opacity = '1';
    trailPath.style.transition = 'none'; // イージングを無効化してリニアな動きにする
    
    // 元のパスの直後に軌跡パスを挿入
    pathElement.parentNode.insertBefore(trailPath, pathElement.nextSibling);

    // 移動設定
    const animationConfig = {
      speed: 20, // 線を渡る速度
      direction: 1 // 左から右へ
    };

    // 軌跡更新用の変数
    let trailDistance = 0;
    
    // アニメーションループ
    const animatePageHeaderLightDot = () => {
      if (!isAnimating) return;
      
      // パス上の現在位置を取得
      const point = pathElement.getPointAtLength(currentDistance);
      
      // SVGの境界を取得
      const svgRect = pathElement.closest('svg').getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      
      // SVGのviewBox設定を取得
      const svg = pathElement.closest('svg');
      const viewBox = svg.viewBox.baseVal;
      
      // viewBox座標から画面座標に変換
      const scaleX = svgRect.width / viewBox.width;
      const scaleY = svgRect.height / viewBox.height;
      
      const screenX = svgRect.left + (point.x - viewBox.x) * scaleX;
      const screenY = svgRect.top + (point.y - viewBox.y) * scaleY;
      
      lightDot.style.left = (screenX - containerRect.left) + 'px';
      lightDot.style.top = (screenY - containerRect.top) + 'px';

      // 次の位置に移動
      currentDistance += animationConfig.speed * animationConfig.direction;
      
      // 光の移動後に軌跡を更新（少し遅延させる）
      setTimeout(() => {
        trailDistance = currentDistance - (animationConfig.speed * 0.5);
        const trailLength = Math.max(0, trailDistance);
        trailPath.style.strokeDashoffset = pathLength - trailLength;
      }, 16); // 1フレーム分遅延
      
      // 線の終端に到達したらアニメーションを停止
      if (currentDistance >= pathLength) {
        isAnimating = false;
        lightDot.style.opacity = '0';
        // 軌跡は完全に表示されたままにする
        trailPath.style.strokeDashoffset = '0';
        return;
      }
      requestAnimationFrame(animatePageHeaderLightDot);
    };

    // スクロールトリガーでアニメーション開始（一度だけ）
    ScrollTrigger.create({
      trigger: container,
      start: 'top 90%',
      onEnter: () => {
        if (!animationStarted) {
          animationStarted = true;
          isAnimating = true;
          currentDistance = 0; // 始端から開始（左から右へ）
          lightDot.style.opacity = '1';
          
          animatePageHeaderLightDot();
          
        }
      }
    });
  };

  // 初期化実行
  initPageHeaderLightAnimation();
} 